<template>
    <div class="text-center">
        <h1>404</h1>
        <p class="text-subtitle-1">
            {{ $t('views.errors.not_found.page_not_found') }}
        </p>
    </div>
</template>

<script>
export default {
name: "NotFound"
}
</script>

<style scoped>

</style>
